<template>
  <div class="fill-width">
    <the-button :block="buttonSecondary" small :secondary="buttonSecondary" @click="openDialog">
      <i-custom-invite class="mr-1" />
      <span>{{ $translate("InviteMembersButton.invite") }}</span>
    </the-button>
    <message-dialog :dialog="dialog" :fullscreen="$vuetify.display.mobile" :persistent="$vuetify.display.mobile" @cancel="dialog = false">
      <template #header v-if="$vuetify.display.mobile">
        <header-mobile header-mobile post-background>
          <template #item-left>
            <the-button icon small @click="dialog = false">
              <i-custom-close class="close-icon" />
            </the-button>
          </template>
          <template #item-middle>
            <div class="font-weight-bold font-size-big">
              {{ $translate("InviteMembersButton.headerMobile") }}
            </div>
          </template>
        </header-mobile>
      </template>

      <template #title>{{ $translate("InviteMembersButton.headerDesktop") }}</template>
      <template #content>
        <section class="font-size-big content">
          <div v-if="$vuetify.display.mobile" class="mb-4 mt-3">{{ $translate("InviteMembersButton.subHeaderMobile") }}</div>
          <div class="mb-4 mt-3">{{ $translate("InviteMembersButton.subHeader") }}</div>
          <template v-if="$vuetify.display.mobile && isMobile">
            <div class="text-center">
              <the-button :disabled="!link" small class="mt-1 mb-6 px-12" @click="share">
                <i-custom-share class="mr-1" />
                <span>{{ $translate("common.share") }}</span>
              </the-button>
            </div>
          </template>

          <div class="d-flex align-center mt-12" align-center>
            <text-field ref="textField" :model-value="link" readonly @click.native="$refs.textField.select()" />
            <the-button
              :disabled="!link"
              :small="$vuetify.display.mobile"
              class="my-0 mr-0 ml-2"
              :class="{ 'px-4': $vuetify.display.mobile }"
              :secondary="$vuetify.display.mobile"
              :loading="loading"
              @click="copyLink"
            >
              <i-custom-link v-if="$vuetify.display.mobile" class="mr-1" />
              <span v-if="$vuetify.display.mobile">{{ $translate("InviteMembersButton.copy") }}</span>
              <span v-else>{{ $translate("InviteMembersButton.copyLink") }}</span>
            </the-button>
          </div>
        </section>
      </template>

      <template #cancel v-if="!$vuetify.display.mobile">{{ $translate("common.close") }}</template>
    </message-dialog>
  </div>
</template>

<script>
import { mapGetters } from "pinia"

import { useConfigurationStore } from "@/store/configuration.js"

import * as referralCodesApi from "@/api/referralCodesApi.js"

import * as clientShare from "@/services/clientShare.js"
import * as clipboard from "@/services/clipboard.js"
import * as environment from "@/services/environment.js"

import { registerAnalyticsEvent } from "@/services/analytics.js"

export default {
  props: {
    buttonSecondary: {
      type: Boolean,
      default: false
    },
    analyticsKey: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      link: null,
      loading: false,
      isMobile: environment.isMobile()
    }
  },
  computed: {
    ...mapGetters(useConfigurationStore, ["configuration"])
  },
  watch: {
    dialog(value) {
      if (value) {
        this.getLink()
      }
    }
  },
  methods: {
    async getLink() {
      try {
        this.loading = true
        const { invite_link: link } = await referralCodesApi.inviteLink()
        this.link = link.url
      } catch (err) {
        this.$reportError(err)
      } finally {
        this.loading = false
      }
    },
    async copyLink() {
      await clipboard.write(this.link)
      this.$eventBus.$emit("notify", this.$translate("InviteMembersButton.linkCopied"))
      this.registerCopyEvent()
    },
    share() {
      clientShare.share(
        this.link,
        this.$translate("InviteMembersButton.shareInfo", {
          appName: this.configuration.appTitle,
          link: this.link
        })
      )
      this.registerShareEvent()
    },

    registerCopyEvent() {
      registerAnalyticsEvent({
        name: "invite-link-copy",
        attributes: { key: this.analyticsKey }
      })
    },
    registerShareEvent() {
      registerAnalyticsEvent({
        name: "invite-link-share",
        attributes: { key: this.analyticsKey }
      })
    },
    openDialog() {
      this.dialog = true
      this.$emit("open")
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  .v-btn--small {
    height: 32px;
  }
}
</style>
